import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { makeCancelable } from '../../../lib/utils.js';
import { retrieveInitiativeUpload } from '../../../modules/initiativeUploads.js';
import AuthorizedAction from '../../AuthorizedAction.js';

const MAX_ATTEMPTS = 12;

class InitiativeUploadStatus extends React.PureComponent {
  static completed(initiative) {
    return (
      initiative.initiativeUpload &&
      initiative.initiativeUpload.status === 'completed'
    );
  }

  state = {
    attempts: 0,
    showInfoModal: false,
  };

  componentDidMount() {
    const {
      initiative: { initiativeUpload },
    } = this.props;

    if (initiativeUpload) {
      this.updateStatus();
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      initiative: { initiativeUpload },
    } = this.props;

    if (!initiativeUpload && nextProps.initiative?.initiativeUpload) {
      // Upload was just added
      this.updateStatus(nextProps);
    } else if (
      initiativeUpload &&
      nextProps.initiative.initiativeUpload &&
      initiativeUpload.id !== nextProps.initiative.initiativeUpload.id
    ) {
      this.updateStatus(nextProps);
    }
  }

  componentWillUnmount() {
    // Ensure no further updates are triggered
    clearTimeout(this.timeoutId);
    if (this.cancelablePromise) {
      this.cancelablePromise.cancel();
    }
  }

  updateStatus(nextProps) {
    // Allow passing nextProps or default to this.props
    const {
      initiative: { initiativeUpload },
      retrieveInitiativeUpload,
    } = nextProps || this.props;
    const { attempts } = this.state;
    const delay = (attempts + 1) * 2000;

    if (initiativeUpload?.status === 'completed' || attempts === MAX_ATTEMPTS) {
      return;
    }

    this.setState({ attempts: attempts + 1 });

    this.cancelablePromise = makeCancelable(
      retrieveInitiativeUpload(initiativeUpload.id)
    );

    this.cancelablePromise.promise.then(() => {
      this.timeoutId = setTimeout(() => this.updateStatus(), delay);
    });
  }

  renderStatus() {
    const { initiative, onDownloadErrorsCsv } = this.props;
    const { attempts } = this.state;
    const { initiativeUpload, groupStructureErrors } = initiative;

    if (attempts === MAX_ATTEMPTS) {
      return (
        <div className="component-xl component-bg-white component-border-bottom text-center">
          <h3 className="text-danger">
            Something went wrong while working with participants structure.
          </h3>
        </div>
      );
    }

    if (initiativeUpload?.status === 'processing') {
      return (
        <div className="component-xl component-bg-white component-border-bottom text-center">
          <h3>Processing participants structure - Please Wait.</h3>
        </div>
      );
    }

    return initiativeUpload && groupStructureErrors ? (
      <div className="component-xl component-bg-white component-border-bottom text-center">
        <h3 className="text-danger">
          There was an issue with participating groups CSV.
        </h3>
        <br />
        <br />
        <p className="no-margin">
          An email with instructions has been sent to {initiative.ownerName}.
        </p>

        {initiative.project[
          `manage${initiative.type.charAt(0).toUpperCase() + initiative.type.slice(1)}Initiatives`
        ] ? (
          <AuthorizedAction
            action="update"
            subject={`${initiative.type}Initiative`}
          >
            <p className="no-margin">
              Please download the CSV error report
              <button
                type="button"
                className="btn-link"
                onClick={onDownloadErrorsCsv}
              >
                here
              </button>
              or in the email’s attachments.
            </p>
          </AuthorizedAction>
        ) : null}
      </div>
    ) : null;
  }

  render() {
    return this.renderStatus();
  }
}

InitiativeUploadStatus = connect(null, { retrieveInitiativeUpload })(
  InitiativeUploadStatus
);

InitiativeUploadStatus.propTypes = {
  initiative: PropTypes.shape({
    groupStructureErrors: PropTypes.bool,
    initiativeUpload: PropTypes.shape({
      id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
      errorsCsv: PropTypes.string,
    }),
  }).isRequired,
};

export default InitiativeUploadStatus;
